import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Header, Icon, Tab } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import _ from 'lodash';
import { ACL } from 'shared/constants';
import aclService from 'shared/lib/acl';

// Components
import NetworkDashboard from 'components/NetworkDashboard/Dashboard';
import RecessiList from 'components/RecessoList/List';
import TutorList from 'components/TutorList/List';

const TitleHeader = Styled(Header)`
  margin-top: 15px;
`;

const networkManagmentTabs = {
  dashboard: 'Dashboard rete',
  recessi: 'Gestione recessi',
  tutor: 'Tutor',
};
const getActiveTabIndex = (tab) => Object.keys(networkManagmentTabs).indexOf(tab);

export class NetworkManagment extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: getActiveTabIndex(this.props.match.params.tab),
    };
  }

  onTabChange = (event) => {
    const tab = _.findKey(networkManagmentTabs, (text) => text === event.currentTarget.text);
    if (tab) {
      this.props.history.push(`/gestione-rete/${tab}`);
      this.setState({ activeTab: getActiveTabIndex(tab) });
    }
  };

  networkAllPanes = [
    {
      menuItem: networkManagmentTabs.dashboard,
      render: () => (
        <Tab.Pane attached={false}>
          <NetworkDashboard {...this.props} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: networkManagmentTabs.recessi,
      render: () => (
        <Tab.Pane attached={false}>
          <RecessiList {...this.props} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: networkManagmentTabs.tutor,
      render: () => (
        <Tab.Pane attached={false}>
          <TutorList {...this.props} />
        </Tab.Pane>
      ),
    },
  ];

  networkPanes = [
    {
      menuItem: networkManagmentTabs.dashboard,
      render: () => (
        <Tab.Pane attached={false}>
          <NetworkDashboard {...this.props} />
        </Tab.Pane>
      ),
    },
  ];

  render() {
    return (
      <div>
        <Helmet>
          <title>Gestione rete</title>
          <meta name="description" content="Gestione rete" />
        </Helmet>

        <TitleHeader as="h2">
          <Icon name="sitemap" />
          <Header.Content>Gestione rete</Header.Content>
        </TitleHeader>

        <Tab
          menu={{ secondary: true, pointing: true }}
          activeIndex={this.state.activeTab}
          onTabChange={this.onTabChange}
          panes={aclService.check(this.props.auth, ACL.CAN_VIEW_SECTION_GESTIONE_RETE_ALL_TABS) ? this.networkAllPanes : this.networkPanes}
        />
      </div>
    );
  }
}

NetworkManagment.propTypes = {
  /** Used for manage history of the browser -> redirect */
  history: PropTypes.object,
  /** Containes information about the URL -> used for get the neo profile ID  */
  match: PropTypes.object,
  /** Function for call the notification system */
  // notification: PropTypes.func,
  /** Object with data of logged user */
  auth: PropTypes.object,
};

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

const withConnect = connect(null, mapDispatchToProps);

export default compose(withConnect)(NetworkManagment);



// WEBPACK FOOTER //
// ./app/containers/NetworkManagment/index.js